import { Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Pagination, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Tooltip } from '@mui/material';
import { paginationStyle } from '../../theme/formStyles';
import React, { useEffect, useState, useRef } from 'react';
import SearchBox from '../Common/SearchBox';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import FilterListIcon from '@mui/icons-material/FilterList';
import { getAllAssets, getAllAssetsLocationDetails, getAllClientAssets } from '../../Redux/actions';
import { useDispatch } from 'react-redux';
import { Edit } from '@mui/icons-material';
import { calculateDueDays, getMaintenanceStatus, updateParams } from '../../utils';
import Filter from '../Common/Filter';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlaceIcon from '@mui/icons-material/Place';
import useBackActionDetection from '../../utils/UseBackActionDetection';
import DownloadIcon from '@mui/icons-material/Download';
import { exportFullAssetTableToExcel } from '../../utils/Common';
import InventoryList from './InventoryList';

export default function ClientAssetList() {

    let { client_id: client_id, tabId } = useParams()
    const [queryParams, setQueryParams] = useSearchParams();
    const existingParams = Object.fromEntries([...queryParams])

    let navigate = useNavigate()
    const goToRoutes = (routeApi) => {
        navigate(routeApi, { replace: true });
    }
    const location = useLocation();
    const dispatch = useDispatch();
    const [responseData, setResponseData] = useState([])
    const [responseDataWithoutPage, setResponseDataWithoutPage] = useState([])
    const [showLoader, setShowLoader] = useState(true)
    const [hoveredRowId, setHoveredRowId] = useState(null);
    const [isSearchOrFilterApplied, setIsSearchOrFilterApplied] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(null)
    const [showFilterDialog, setShowFilterDialog] = useState(false);
    const [currentPage, setCurrentPage] = useState(null);
    const [locationDetails, setLocationDetails] = useState([]);
    const [showMapModal, setShowMapModal] = useState(false);
    const [tabSwitch, setTabSwitch] = useState(false);
    const [totalAssetValue, setTotalAssetValue] = useState(0);
    const [totalClientAssetValue, setTotalClientAssetValue] = useState(0);
    const [totalClientsCount, setTotalClientsCount] = useState(0);

    let tableColumns = [];

    if ((tabId === 'treatment') || (tabId === 'distribution')) {
        tableColumns.push('Sl. No.', 'Facility', 'Item Name', 'Serial Number', 'Installation Date', 'Asset Cost', 'Associated Meters', 'Maintenance Schedule', 'Maintenance Status', 'Total Cost', '')
    } else {
        // Add Client column when client_id is not present (inventory view)
        if (!client_id) {
            tableColumns.push('Sl. No.', 'Client', 'Facility', 'Item Name', 'Serial Number', 'Installation Date', 'Particulars', 'Asset Cost', 'Total Cost', '')
        } else {
            tableColumns.push('Sl. No.', 'Facility', 'Item Name', 'Serial Number', 'Installation Date', 'Particulars', 'Asset Cost', 'Total Cost', '')
        }
    }
    let tableContent = null;
    const mapRef = useRef(null);

    const isBackAction = useBackActionDetection();

    useEffect(() => {
        // if (!tabId) {
        //     queryParams.set('tab', 'leased-asset');
        //     navigate({ search: queryParams.toString() }, { replace: true });
        // }
        if (existingParams?.page) {
            return
        }
        updateQueryParams({ page: 1 })
        fetchData();
    }, [queryParams, location.search]);

    useEffect(() => {
        setIsSearchOrFilterApplied(false);
        fetchData();
    }, [queryParams])

    const fetchData = () => {
        setShowLoader(true)
        const params = {
            ...existingParams,
            title: existingParams?.search,
            page: isSearchOrFilterApplied ? 1 : existingParams?.page,
            category: tabId === 'leased-asset' ? 'Leased Asset' : (tabId === 'treatment' ? 'Treatment' : (tabId === 'distribution' ? 'Distribution' : 'Sale'))
        }
        if (existingParams?.page) {
            if (client_id) {
                dispatch(getAllClientAssets(client_id, params)).then((res) => {
                    if (res && res.status === 200) {
                        setResponseData(res?.data?.clientAssetData)
                        setTotalPages(res?.data?.totalPages)
                        setTotalCount(res?.data?.totalItems);
                        setCurrentPage(res?.data?.currentPage)
                        setTotalClientAssetValue(res?.data?.totalClientAssetValue)
                        setShowLoader(false)
                    }
                });
                dispatch(getAllAssetsLocationDetails(client_id)).then((res) => {
                    if (res && res.status === 200) {
                        setLocationDetails(res?.data?.locationData)
                    }
                })
            } else {
                dispatch(getAllAssets(params)).then((res) => {
                    if (res && res.status === 200) {
                        setResponseData(res?.data?.clientAssetData)
                        setTotalPages(res?.data?.totalPages)
                        setTotalCount(res?.data?.totalItems);
                        setCurrentPage(res?.data?.currentPage)
                        setTotalAssetValue(res?.data?.totalAssetValue)
                        setTotalClientsCount(res?.data?.totalClientsCount || 0)
                        setShowLoader(false)
                    }
                })
            }
        }
    };

    useEffect(() => {
        if (showMapModal) {
            setTimeout(() => {
                const mapContainer = document.getElementById('modal-map');
                if (mapContainer) {
                    initMap();
                }
            }, 100);
        }
    }, [showMapModal]);


    const categoryColorMap = {
        'Supply': 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
        'Distribution': 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
        'Treatment': 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
        'Sanitary & Plumbing': 'http://maps.google.com/mapfiles/ms/icons/orange-dot.png',
        'Water Conservation & Monitoring': 'http://maps.google.com/mapfiles/ms/icons/purple-dot.png',
        'Cooling & HVAC Water Systems': 'http://maps.google.com/mapfiles/ms/icons/pink-dot.png',
        'Fire Safety': 'http://maps.google.com/mapfiles/ms/icons/lightblue-dot.png',
        'Stormwater Management': 'http://maps.google.com/mapfiles/ms/icons/brown-dot.png',
    };

    const getMarkerIconUrl = (category) => {
        return categoryColorMap[category] || 'http://maps.google.com/mapfiles/ms/icons/red-dot.png';
    };


    const initMap = () => {
        const map = new window.google.maps.Map(document.getElementById('modal-map'), {
            center: { lat: 12.9715987, lng: 77.5945627 },
            zoom: 8,
        });

        locationDetails.forEach((item) => {
            if (item.geo_proof_lat && item.geo_proof_lon) {
                const markerIcon = getMarkerIconUrl(item.category);
                const marker = new window.google.maps.Marker({
                    position: { lat: parseFloat(item.geo_proof_lat), lng: parseFloat(item.geo_proof_lon) },
                    map,
                    icon: markerIcon,
                    // title: item.name,
                });
                const infoWindow = new window.google.maps.InfoWindow({
                    content: `
                        <div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.5; max-width: 310px;">
                            <strong style="font-weight: bold; font-size: large;">${item.name}</strong><br>
                            <strong>${item.category}</strong><br>
                            <span style="color: #1976d2;">Latitude:</span> ${item.geo_proof_lat} | <span style="color: #1976d2;">Longitude:</span> ${item.geo_proof_lon}
                        </div>
                    `,
                });
                // infoWindow.open(map, marker);
                marker.addListener('click', () => {
                    infoWindow.open(map, marker);
                });
            }
        });
    };

    const updateQueryParams = (params) => {
        const searchParams = updateParams(existingParams, params)
        navigate({ search: searchParams.toString() }, { replace: true });
    }

    const handleSearch = (value) => {
        updateQueryParams({ search: value, page: 1 });
        setIsSearchOrFilterApplied(true);
    }

    const handlePageChange = (event, newPage) => {
        updateQueryParams({ page: newPage });
    };

    const handleChangeTab = (event, newValue) => {
        // setUserData(null)
        // setClientUsers(null)
        setShowLoader(true)
        setQueryParams({ page: 1 });
        setTabSwitch(true);
    };

    const handleTabSwitch = () => {
        setTabSwitch(false);
    };

    const getStatusClassName = (item) => {
        if (item === 'Pending') {
            return 'w3-red';
        } else if (item === 'Completed') {
            return 'w3-green';
        } else {
            return 'w3-yellow';
        }
    };

    const handleDownload = () => {
        const params = {
            facility_id: existingParams.facility_id,
            client_id: existingParams.client_id,
            category: tabId === 'leased-asset' ? 'Leased Asset' : (tabId === 'treatment' ? 'Treatment' : (tabId === 'distribution' ? 'Distribution' : 'Sale'))
        }

        // Filter out inactive assets from grouped data
        const filterActiveAssets = (groupedData) => {
            return groupedData?.map(group => ({
                ...group,
                assets: group.assets?.filter(asset =>
                    asset.inactive === 'false' || asset.inactive === null || asset.inactive === undefined
                )
            })).filter(group => group.assets?.length > 0);
        };

        if (client_id) {
            dispatch(getAllClientAssets(client_id, params)).then((res) => {
                if (res?.status === 200) {
                    const activeAssetsData = filterActiveAssets(res?.data?.allClientAssetData);
                    exportFullAssetTableToExcel(activeAssetsData, tabId, client_id);
                }
            })
        } else {
            dispatch(getAllAssets(params)).then((res) => {
                if (res?.status === 200) {
                    exportFullAssetTableToExcel(res?.data?.allAssetData, tabId, client_id);
                }
            })
        }
    }

    let assetList = []
    const itemsPerPage = 5;

    if (showLoader) {
        assetList = (
            <TableRow>
                <TableCell colSpan={12} align="center">
                    <CircularProgress />
                </TableCell>
            </TableRow>
        )
    } else if (!showLoader && responseData?.length <= 0) {
        assetList = (
            <TableRow>
                <TableCell colSpan={12} align="center">
                    <h5 className="w3-text-grey">No Data Found</h5>
                </TableCell>
            </TableRow>
        );
    } else {
        assetList = responseData?.map((fItem, facilityIndex) => {
            // Only include active assets in total cost calculation
            const totalCost = fItem.assets.reduce((sum, item) => {
                const isActive = item.inactive === 'false' || item.inactive === null || item.inactive === undefined;
                return sum + (isActive ? (parseFloat(item.cost) || 0) : 0);
            }, 0);
            const isLastFacility = facilityIndex === responseData.length - 1;

            return fItem.assets.map((item, index) => {
                const maintenanceDueDays = calculateDueDays(
                    item?.operation_start_date,
                    item?.componentSchedule,
                    item?.assetMaintenance,
                    item?.operation_end_date
                );

                const maintenanceStatus = getMaintenanceStatus(
                    maintenanceDueDays?.scheduleItem?.offset_time_days ?? null,
                    item?.assetMaintenance,
                    maintenanceDueDays?.maintenanceCompleted ?? null
                );

                return (
                    <TableRow
                        key={`${item.unique_id}-${index}`}
                        onMouseEnter={() => setHoveredRowId(item?.unique_id)}
                        onMouseLeave={() => setHoveredRowId(null)}
                        sx={{
                            position: 'relative',
                            '&::after': index === fItem.assets.length - 1 && !isLastFacility ? {
                                content: '""',
                                position: 'absolute',
                                bottom: 0,
                                left: '5%',
                                width: '90%',
                                borderBottom: '1px solid #a1a1a1',
                            } : {},
                        }}
                    >
                        {index === 0 && (
                            <>
                                <TableCell style={{ borderBottom: 'none' }} rowSpan={fItem.assets.length}>{(currentPage - 1) * itemsPerPage + facilityIndex + 1}</TableCell>
                                {/* Add Client column for inventory view (when client_id is not present) */}
                                {!client_id && (tabId === 'leased-asset' || tabId === 'sale') && (
                                    <TableCell style={{ borderBottom: 'none' }} rowSpan={fItem.assets.length}>
                                        {item?.facility?.client?.name || '--'}
                                    </TableCell>
                                )}
                                <TableCell style={{ borderBottom: 'none' }} rowSpan={fItem.assets.length}>{item?.facility?.facility_name}</TableCell>
                            </>
                        )}
                        <TableCell style={index === fItem.assets.length - 1 ? { borderBlock: 'none' } : {}}>
                            <div>{item?.assetName?.asset_name || '--'}</div>
                            {client_id && (
                                <Chip
                                    size="small"
                                    label={item?.inactive === 'true' ? 'Inactive' : 'Active'}
                                    sx={{
                                        mt: 0.5,
                                        height: '18px',
                                        fontSize: '10px',
                                        backgroundColor: item?.inactive === 'true' ? '#ffebee' : '#e8f5e9',
                                        color: item?.inactive === 'true' ? '#c62828' : '#2e7d32',
                                        fontWeight: 600
                                    }}
                                />
                            )}
                        </TableCell>
                        <TableCell style={index === fItem.assets.length - 1 ? { borderBlock: 'none' } : {}}>{item?.serial_number || '--'}</TableCell>
                        <TableCell style={index === fItem.assets.length - 1 ? { borderBlock: 'none' } : {}}>{new Date(item?.installation_date).toLocaleString(undefined, {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                        })}</TableCell>
                        {((tabId === 'leased-asset') || (tabId === 'sale')) && (<TableCell style={index === fItem.assets.length - 1 ? { borderBlock: 'none', whiteSpace: 'pre-line', } : { whiteSpace: 'pre-line', }}>{item?.particulars ? `${item?.particulars}` : '--'}</TableCell>)}
                        <TableCell style={index === fItem.assets.length - 1 ? { borderBlock: 'none' } : {}}>
                            {item?.inactive === 'true' ? '-' : (item?.cost ? `₹ ${item?.cost}` : '--')}
                        </TableCell>
                        {((tabId === 'distribution') || (tabId === 'treatment')) && (<TableCell>
                            {item?.assetMeter?.meter ? (
                                <Chip
                                    key={item?.assetMeter?.meter?.mid}
                                    size="small"
                                    color="primary"
                                    label={item?.assetMeter?.meter?.meterid}
                                    onClick={() => {
                                        navigate(`/client/${client_id}/meters/trending-analysis/${item?.assetMeter?.meter?.mid}`)
                                    }}
                                    sx={{ '.MuiChip-label': { padding: '0px' } }}
                                    style={{
                                        fontSize: '0.75rem',
                                        height: '20px',
                                        padding: '0 4px',
                                        margin: '2px',
                                    }}
                                />
                            ) : '--'}
                        </TableCell>)}
                        {((tabId === 'distribution') || (tabId === 'treatment')) && (<TableCell style={index === fItem.assets.length - 1 ? { borderBlock: 'none' } : {}}>
                            <div style={{ color: maintenanceDueDays?.overdueDays ? 'red' : 'black', fontWeight: 500 }}>
                                {maintenanceDueDays?.overdueDays
                                    ? `Overdue By ${maintenanceDueDays?.overdueDays} Days`
                                    : maintenanceDueDays?.dueDays !== null
                                        ? `In ${maintenanceDueDays?.dueDays} Days`
                                        : '--'}
                            </div>
                            <div style={{ fontSize: '10px' }}>
                                {maintenanceDueDays?.actualMaintenanceDate ? `(${maintenanceDueDays?.actualMaintenanceDate})` : null}
                            </div>
                        </TableCell>)}
                        {((tabId === 'distribution') || (tabId === 'treatment')) && (<TableCell style={index === fItem.assets.length - 1 ? { borderBlock: 'none' } : {}}>
                            {maintenanceStatus ? (
                                <Chip
                                    style={{ width: '78px', display: 'flex', justifyContent: 'center' }}
                                    size="small"
                                    className={getStatusClassName(maintenanceStatus?.status)}
                                    label={maintenanceStatus?.status}
                                />
                            ) : '--'}
                        </TableCell>)}
                        {index === 0 && (
                            <TableCell style={{ borderBottom: 'none' }} rowSpan={fItem.assets.length}>
                                <Box component="div" display="flex" flexDirection="row" alignItems="center" gap={1}>
                                    <div className="font-semibold text-black">₹ {totalCost.toLocaleString()}</div>
                                </Box>
                            </TableCell>

                        )}
                        {index === 0 && (
                            <TableCell style={{ borderBottom: 'none' }} rowSpan={fItem.assets.length}>
                                <Box component="div" display="flex" justifyContent={"right"} >
                                    <Tooltip title="Details">
                                        <IconButton aria-label="details"
                                            style={{ opacity: hoveredRowId === item?.unique_id ? 1 : 0, paddingLeft: '0px', marginRight: '10px' }}
                                            onClick={(e) => {
                                                client_id ?
                                                    navigate(`/client/${client_id}/client-assets/${item?.facility?.id}/${tabId}/details`) :
                                                    navigate(`/inventory-management/${item?.client_id}/${item?.facility?.id}/${tabId}/details`)
                                                localStorage.setItem('clientAssetQueryParams', queryParams);
                                            }}
                                        >
                                            <VisibilityIcon className="cursor-pointer" />
                                        </IconButton>
                                    </Tooltip>
                                    {client_id && (<Tooltip title="Edit">
                                        <IconButton aria-label="edit"
                                            style={{ opacity: hoveredRowId === item?.unique_id ? 1 : 0, paddingLeft: '0px' }}
                                            onClick={() => {
                                                navigate((item?.category === 'Leased Asset' || item?.category === 'Sale') ?
                                                    `/client/${client_id}/client-assets/${item.facility?.id}/${item?.category.toLowerCase().trim().replace(/\s+/g, '-')}/edit` :
                                                    `/client/${client_id}/client-assets/${item.facility?.id}/${item?.category.toLowerCase().trim().replace(/\s+/g, '-')}/maintenance`
                                                );
                                                localStorage.setItem('clientAssetQueryParams', queryParams);
                                            }}
                                        >
                                            <Edit className="cursor-pointer"
                                                style={{ color: 'black' }}
                                            />
                                        </IconButton>
                                    </Tooltip>)}
                                </Box>
                            </TableCell>
                        )}
                    </TableRow>
                );
            });
        });
    }

    tableContent = assetList

    const handleOpenMapModal = () => {
        setShowMapModal(true);
    };

    const handleCloseMapModal = () => {
        setShowMapModal(false);
    };

    return (
        <div className='w3-padding-large'>
            <Grid container>
                <Grid item md={12}>
                    <Grid item container spacing={8} paddingY={2}>
                        {client_id && (<Grid item md={6}>
                            <Button
                                style={{ backgroundColor: '#008080', color: 'white' }}
                                variant="contained"
                                onClick={() => {
                                    localStorage.setItem('clientAssetTabId', tabId)
                                    localStorage.setItem('clientAssetQueryParams', queryParams);
                                    navigate(`/client/${client_id}/client-assets/create`);
                                }}
                            >Add Assets</Button>
                            <Button
                                variant="outlined"
                                style={{ marginLeft: '10px', borderColor: '#008080', color: '#008080' }}
                                onClick={handleOpenMapModal}
                                startIcon={<PlaceIcon />}
                            >
                                View Assets on Map
                            </Button>
                        </Grid>)}
                        {!client_id && (<Grid item md={12} container justifyContent="flex-end" direction="row">
                            <Grid item container md={12} direction="row">
                                <Grid item md={6} container justifyContent="flex-start">
                                    {(tabId !== 'inventory') && (<Grid item display='flex'>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Box sx={{ fontWeight: 600, color: 'black', backgroundColor: 'white', padding: '10px', borderRadius: '4px' }}>
                                                Total Asset Value: &nbsp;
                                                <span style={{ fontWeight: 600, color: '#e68a00', fontSize: '18px' }}>
                                                    {showLoader ? <CircularProgress size={20} color="primary" /> : (client_id ? `₹ ${totalClientAssetValue.toFixed(1)}` : `₹ ${totalAssetValue.toFixed(1)}`)}
                                                </span>
                                            </Box>
                                            {(tabId === 'leased-asset' || tabId === 'sale') && (
                                                <>
                                                    <Box sx={{ fontWeight: 600, color: 'black', backgroundColor: 'white', padding: '10px', borderRadius: '4px' }}>
                                                        No. of Buildings: &nbsp;
                                                        <span style={{ fontWeight: 600, color: '#e68a00', fontSize: '18px' }}>
                                                            {showLoader ? <CircularProgress size={20} color="primary" /> : totalCount}
                                                        </span>
                                                    </Box>
                                                    <Box sx={{ fontWeight: 600, color: 'black', backgroundColor: 'white', padding: '10px', borderRadius: '4px' }}>
                                                        No. of Clients: &nbsp;
                                                        <span style={{ fontWeight: 600, color: '#e68a00', fontSize: '18px' }}>
                                                            {showLoader ? <CircularProgress size={20} color="primary" /> : totalClientsCount}
                                                        </span>
                                                    </Box>
                                                </>
                                            )}
                                        </Box>
                                    </Grid>)}
                                </Grid>
                                <Grid item container md={6} justifyContent='end' alignItems="center">
                                    <Grid item>
                                        <h6 style={{ fontSize: '15px', paddingRight: '5px', margin: 0, whiteSpace: 'nowrap' }}>Search By:</h6>
                                    </Grid>
                                    <Grid item>
                                        <SearchBox
                                            value={queryParams.get('search') || ''}
                                            placeholder='Item Name / Serial Number'
                                            search={handleSearch}
                                            isBrowserBackAction={isBackAction}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <IconButton
                                            onClick={() => setShowFilterDialog(true)}
                                            title="Apply Filter">
                                            <FilterListIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>)}
                        {!client_id && (tabId === 'leased-asset' || tabId === 'sale') && (
                            <Grid container justifyContent='space-between'>
                                <Grid item>
                                </Grid>
                                <Grid item display='flex'>
                                    <Button
                                        variant="contained"
                                        style={{ marginBottom: 12, backgroundColor: '#008080', color: 'white' }}
                                        onClick={() => handleDownload()}
                                    >
                                        Download
                                    </Button>
                                </Grid>
                            </Grid>
                        )}
                        {client_id && (<Grid item md={6} container justifyContent="flex-end" direction="row">
                            <Grid item container md={12} direction="row">
                                <Grid item md={11} container justifyContent="flex-end">
                                    <h6 style={{ paddingRight: '5px', fontSize: '15px' }}>Search By: </h6>
                                    <SearchBox
                                        value={queryParams.get('search') || ''}
                                        placeholder='Item Name / Serial Number'
                                        search={handleSearch}
                                        isBrowserBackAction={isBackAction}
                                    />
                                </Grid>
                                <Grid item container md={1} justifyContent="flex-end">
                                    <IconButton
                                        onClick={() => setShowFilterDialog(true)}
                                        title="Apply Filter">
                                        <FilterListIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>)}

                    </Grid>
                    {client_id && (<Grid container justifyContent='space-between'>
                        <Grid item>
                        </Grid>
                        {(tabId !== 'inventory') && (<Grid item display='flex'>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Tooltip title="Download">
                                    <Button
                                        style={{ borderColor: '#008080', color: '#008080' }}
                                        variant="outlined"
                                        onClick={() => handleDownload()}
                                        sx={{ minWidth: '42px', padding: '6px', height: '42px' }}
                                    >
                                        <DownloadIcon />
                                    </Button>
                                </Tooltip>
                                <Box sx={{ fontWeight: 600, color: 'black', backgroundColor: 'white', padding: '10px', borderRadius: '4px' }}>Total Asset Value</Box>
                                <Box sx={{ fontWeight: 600, color: '#e68a00', fontSize: '18px', backgroundColor: 'white', padding: '8px 10px', borderRadius: '4px', display: 'flex', justifyContent: 'center' }}>{showLoader ? <CircularProgress size={20} color="primary" /> : (client_id ? `₹ ${totalClientAssetValue.toFixed(1)}` : `₹ ${totalAssetValue.toFixed(1)}`)}</Box>
                            </Box>
                        </Grid>)}
                    </Grid>)}
                    <Filter
                        filterArea={client_id ? "Client Assets" : "Inventory"}
                        showFilterDialog={showFilterDialog}
                        setShowFilterDialog={setShowFilterDialog}
                        updateQueryParams={updateQueryParams}
                        queryParams={queryParams}
                        setIsSearchOrFilterApplied={setIsSearchOrFilterApplied}
                        clearFilters={tabSwitch}
                        handleTabSwitch={handleTabSwitch}
                        isBrowserBackAction={isBackAction}

                    />

                    <Grid paddingX={0} paddingY={1}>
                        {(tabId !== 'inventory') && (<TableContainer component={Paper}>
                            <Table aria-label="simple table" style={{ tableLayout: 'auto' }}>
                                <TableHead>
                                    <TableRow>
                                        {tableColumns.map(tCol => (
                                            <TableCell style={{ fontSize: '14px', fontWeight: 'bold' }}>{tCol}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableContent}
                                </TableBody>
                            </Table>
                        </TableContainer>)}
                        {(tabId === 'inventory') && (
                            <InventoryList />
                        )}
                    </Grid>
                </Grid>
                {(responseData && responseData.length > 0 && !showLoader) && (
                    <Grid container item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '24px' }}>
                            <span style={{ fontFamily: '"Helvetica Neue"', fontSize: '13px', color: '#3d3d3d' }}>
                                {Math.min((parseInt(existingParams.page) - 1) * itemsPerPage + 1, totalCount)}-
                                {Math.min(parseInt(existingParams.page) * itemsPerPage, totalCount)} of {totalCount}
                            </span>
                        </Grid>
                        <Pagination
                            page={parseInt(existingParams?.page) || 1}
                            count={totalPages}
                            variant="outlined"
                            shape="rounded"
                            sx={paginationStyle}
                            onChange={handlePageChange}
                        />
                    </Grid>
                )}
            </Grid>
            {showMapModal && (
                <Dialog
                    open={showMapModal}
                    onClose={handleCloseMapModal}
                    maxWidth="lg"
                    fullWidth
                >
                    <DialogTitle>Client Assets</DialogTitle>
                    <DialogContent>
                        <div style={{ width: '100%', height: '400px' }}>
                            <div id="modal-map" style={{ width: '100%', height: '100%' }} />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseMapModal} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>
    )
}